import { Component, Input } from '@angular/core';

/**
 * The social share row for a piece of content.
 *
 * 13 buttons, repeated verbatim in 8 detail templates across both language
 * trees - 104 blocks in total. Keeping them in one place is what let the X
 * rebrand actually land everywhere: the Twitter button is the only one drawn
 * from an inline SVG rather than the icon font, because Font Awesome 4.7 has
 * no X glyph.
 */
@Component({
  selector: 'raksme-share',
  templateUrl: './share.component.html'
})
export class ShareComponent {

  /**
   * Which buttons to show. The CMS stores this as a comma-joined string on the
   * item (`social_shares`); an array is accepted too so callers do not have to
   * normalise it.
   */
  @Input() platforms: string | string[] = '';

  /** The `generalLabels` object. Optional - labelFor() copes without it. */
  @Input() labels: any = {};

  has(platform: string): boolean {
    const p = this.platforms;
    if (!p) { return false; }
    return Array.isArray(p) ? p.indexOf(platform) > -1 : String(p).indexOf(platform) > -1;
  }

  /**
   * A button's name must never depend on a fetch that can fail. When the CMS
   * label is missing the platform's own name is used, so the control is still
   * announced rather than becoming an anonymous icon.
   */
  labelFor(platform: string): string {
    const fromCms = this.labels && this.labels[platform];
    if (fromCms && String(fromCms).trim()) { return String(fromCms).trim(); }
    return platform.charAt(0).toUpperCase() + platform.slice(1);
  }
}
